import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'

const style = theme => ({
    player: {
        fontFamily: theme.typography.fontFamily,
        lineHeight: '22px',
        width: '60%',
        height: '100%',
        fontSize: '14px',
        color: theme.palette.common.white,
        padding: '20px',
        overflowY: 'auto',
        fontWeight: 'bold',
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto 20%',
        '@media (max-width: 420px)': {
            margin: '0',
            width: 'auto',
        },
    },
    title: {
        fontSize: '36px',
        lineHeight: '46px',
        marginBottom: '10px',
    },
    description: {
        lineHeight: '1.5',
        '& a': {
            color: '#009EF9',
        },
        paddingBottom: '30px',
        overflow: 'hidden',
    },
})

const TextPlayer = ({ classes, title, description }) => (
    <div className={classes.player}>
        <div dangerouslySetInnerHTML={{ __html: title }} className={classes.title} />
        <span className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />
    </div>
)

export default compose(injectJss(style))(TextPlayer)
